import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import NoResults from './NoResults';
// Presentational Component
const SearchResults = ({ hasResult, searchTerm, result, onClick }) => {

	const searchResultSection = (title, section) => (
		<div className="search-result-section" style={result[section] && result[section].length ? null : { display: 'none' }}>
			<h3>{title}</h3>
			<ul className="list-unstyled">
				{
					result[section] && result[section].map(match => (
						<li key={match.title}><Link to={match.path} onClick={e => onClick(e, match.title, searchTerm)}>{match.title}</Link></li>
					))
				}
			</ul>
		</div>
	);

	// Styling
	const searchResultStyle = {
		display: hasResult ? null : 'none',
		position: 'absolute',
		top: '5em',
		width: '100%',
		background: 'rgba(255, 255, 255, 0.95)',
		minHeight: 'calc(100% - 5em)',
		zIndex: 1,
	};

	const searchFlexStyle = {
		display: 'flex',
		background: 'transparent',
		justifyContent: 'space-around',
	};

	const noResultStyle = {
		textAlign: 'center',
		wordBreak: 'break-word',
	};

	// const numOfResults = Object.keys(result).reduce((previous, current) => previous.concat(result[current]), []).length;
	const numOfResults = Object.values(result).reduce((previous, current) => previous.concat(current), []).length;

	return (
		<div className="search-results" style={searchResultStyle}>
			{numOfResults > 0 ?
				<div className="search-flex-container" style={searchFlexStyle}>
					{searchResultSection('Getting Started', 'gettingStarted')}
					{searchResultSection('API Reference', 'api')}
					{searchResultSection('JavaScript SDK', 'javascriptSdk')}
					{searchResultSection('Widgets', 'widgets')}
				</div> :
				<div className="search-flex-container" style={noResultStyle}>
					<NoResults searchTerm={searchTerm} onClick={onClick} />
				</div>
			}
		</div>
	);
};

// Properties expected
SearchResults.propTypes = {
	hasResult: PropTypes.bool.isRequired,
	result: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired,
	searchTerm: PropTypes.string.isRequired,
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/search/SearchResults.js